module.exports = __webpack_public_path__ + "static/media/loading.8584c5db.gif";